// extracted by mini-css-extract-plugin
module.exports = {"circle":"Videos_circle___GZS6","triangle":"Videos_triangle__TA5zt"};